import { useCallback } from 'react';
import EditableTitle from './EditableTitle';

interface EditableTaskTitleProps {
  title: string;
  workstreamID: string;
  taskID: string;
  version: number;
  onSaved?: (newTitle: string, newVersion: number) => void;
}

export default function EditableTaskTitle({
  title,
  workstreamID,
  taskID,
  version,
  onSaved,
}: EditableTaskTitleProps) {
  const handleSave = useCallback(async (newTitle: string) => {
    const resp = await fetch(
      `/api/workstreams/${encodeURIComponent(workstreamID)}/tasks/${encodeURIComponent(taskID)}`,
      {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ Version: version, Fields: { Title: newTitle } }),
      },
    );
    if (resp.ok) {
      const data = await resp.json();
      onSaved?.(data.Title, data.Version);
    }
  }, [workstreamID, taskID, version, onSaved]);

  return <EditableTitle title={title} onSave={handleSave} />;
}
